module.exports = __webpack_public_path__ + "img/avans-not-paid.19ba25f9.svg";